import { React, useState, useEffect } from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import "../styles.css";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { useAuthContext } from '../hooks/useAuthContext';
import { useEditProfile } from "../hooks/useEditProfile";
import { useResetPassword } from "../hooks/useResetPassword";
import validator from "validator";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import dayjs from 'dayjs';
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { Link, useNavigate } from "react-router-dom";
import { useQuery } from "react-query";
import { Helmet } from "react-helmet";
import { useLogout } from "../hooks/useLogout";

function Settings() {
  const { user,dispatch } = useAuthContext()
  const {logout} = useLogout();
  const { resetPassword } = useResetPassword()
// const[priceId,setPrice] = useState("");
  const [firstname, setFname] = useState('')
  const [lastname, setLname] = useState('')
  const notify = (response) => toast(response);
  const users = Cookies.get('token')
  // const[subsData,setData] = useState();
  const { editProfile } = useEditProfile()

  const [userInfo, setUserInfo] = useState(null);


const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    if( validator.isLength(firstname,{min:3,max:10}) || validator.isLength(lastname,{min:3,max:10})){
      if(validator.isAlpha(firstname) || validator.isAlpha(lastname) ) {
  
        const response = await editProfile(firstname, lastname);
     
        if (response) {

          notify("Profile Updated")
        }
      }else{
        notify("Enter valid names")
      }
    }else{
      notify("Invalid values")
    }
   
    

  }



  const handleReset = async (e) => {
  e.preventDefault()

    await resetPassword(userInfo[0].email)

   notify("Password reset link may be sent!")
   
  }





//handle razorpay
//keep it for future reference
// const handleRazorPay = async(e) =>{
//   e.preventDefault()

//   const planId = "plan_NQPy6rsEzN8IeQ"

//   const response = await fetch('/razorpay-payment', {
//     method: 'POST',
//     headers: {'Content-Type':'application/json', 
//     'Authorization': `Bearer ${user}`
// },
// body: JSON.stringify({planID:"plan_NQPy6rsEzN8IeQ"}) //price_1OMuSLSAHivKNSZavvRrUdLN -- main

// })
// const json = await response.json()
// window.location.href=json.url;
// }
const fetchDetails = async () => {
  const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/user/info`, {
    headers: {
      'Authorization': `Bearer ${users}`
    }
  });
  const json = await response.json()

  if (response.status === 200) {
    setUserInfo(json)
   return json
  }

}


const {data} = useQuery(
  "userDetails",
  fetchDetails,
  
)

var uInfo =data;



// const handleSubs = async() =>{
//   const data = await getSubs()
//   console.log(data)
//  setData(data.status)
// }

useEffect(() => {
  const users = Cookies.get('token')

  if(!users ){
    logout()
  }

try{

  const User = jwtDecode(users)
  const checkToken = async() =>{
    const isExpired = dayjs.unix(User.exp).diff(dayjs())< 1;
  
  if(!isExpired){
    // fetchDetails()
    // handleSubs()
    
  }else{
    
    const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/user/refresh-token`, {
      method: 'GET',
      headers: {'Content-Type':'application/json',
  },
  credentials:'include'
  })
 
if(response.status === 200){

   const json = await response.json()
   dispatch({ type: 'LOGIN', payload: json.token })
   navigate("/")
}else{
 
logout()
}
  }

}
  


checkToken()
}catch(e){
  if(e.message.includes("Invalid token specified")){
    logout()
  }
}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
 


  if (user) {
    return (


      <div className="min-h-screen max-w-4xl mx-auto px-4 sm:px-6 py-8">
        <Helmet>
                <meta charSet="utf-8" />
                <title>Settings - Content Flash AI</title>
               <meta name="description" content="Content Flash AI is an AI based content generator. Generate blogs, emails,etc in seconds."/>
            </Helmet>
        <div className="row">

        <div className="mb-2">
          <h1 className="text-2xl font-bold font-Rajdhani text-gray-900 dark:text-white">Settings</h1>
          <p className="text-sm text-gray-500 dark:text-gray-400">Manage your profile, plan and billing.</p>
        </div>
          <Tabs
          
            defaultActiveKey="profile"
            id="fill-tab-example"
            className="mt-3 mb-3 tab font-normal text-black"
            nav-justified
            nav-fill
          >
            <Tab eventKey="profile" title="Profile">
              <h3 className=" dark-text-white font-Rajdhani">Profile</h3>
              {uInfo && uInfo.map((info) => (

                <form className="row g-3 profile mt-4 font-medium border-1 p-4 rounded shadow-md" onSubmit={handleSubmit}>
                  <div className="col-md-4 ">

                    <label for="firstname" className="form-label font-Rajdhani">First Name: {info.firstname}</label>

                    <input type="text" className="form-control dark:bg-slate-700 dark:text-slate-300" id="firstname" required onChange={(e) => setFname(validator.trim(validator.escape(e.target.value)))} />

                  </div>
                  <div className="col-md-4">
                    <label for="lastname" className="form-label font-Rajdhani">Last Name: {info.lastname}</label>

                    <input type="text" className="form-control dark:bg-slate-700 dark:text-slate-300" id="lastname" required onChange={(e) => setLname(validator.trim(validator.escape(e.target.value)))} />

                  </div>
                  <div className="col-md-8">

                    <label htmlFor="email" className="form-label font-Rajdhani">Email</label>
                    <input type="email" className="form-control dark:bg-slate-700 dark:text-slate-300 bg-gray-100 cursor-not-allowed" disabled key={info._id ? info._id : ""} value={info.email ? info.email : ""} id="email" />

                  </div>


                  <div className="col-8 profile-button flex">
                    <button type="submit" className="btn dark:bg-[#818998] dark:text-white dark:bg-none dark:rounded-2xl dark:hover:scale-105 dark:hover:bg-[#818998] dark:hover:text-white text-white  bg-gradient-to-r from-indigo-600 to-indigo-500  hover:scale-105">Save</button>
                    <button className="btn dark:bg-[#818998] dark:text-white dark:bg-none dark:rounded-2xl dark:hover:scale-105 dark:hover:bg-[#818998] dark:hover:text-white text-white  bg-gradient-to-r from-indigo-600 to-indigo-500  hover:scale-105 ml-2" onClick={handleReset}>Reset Password?</button>
                  </div>
                  <ToastContainer
                    position="top-right"
                    autoClose={2000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                  />
                </form>
              ))}


            </Tab>
            <Tab eventKey="subscription" title="Subscription">
              <div className="py-8 px-2 font-Rajdhani">
                <h2 className="text-xl font-bold dark:text-white">Plan &amp; Billing</h2>
                <p className="text-gray-500 dark:text-gray-400 mt-1">
                  Your subscription, usage limits, and add-ons now live on the Plans page.
                </p>

                <div className="mt-5 rounded-2xl border border-indigo-200 dark:border-indigo-700/50 bg-indigo-50/60 dark:bg-indigo-900/15 p-6">
                  <div className="flex flex-wrap items-center justify-between gap-4">
                    <div>
                      <h3 className="text-lg font-bold dark:text-white">Plan, usage &amp; add-ons</h3>
                      <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                        See your current plan and status, track responses &amp; AI generations this period, and top up with capacity boosters.
                      </p>
                    </div>
                    <div className="flex flex-wrap gap-2">
                      <Link to="/settings/billing" className="px-5 py-2.5 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold no-underline whitespace-nowrap">
                        Manage billing →
                      </Link>
                      <Link to="/settings/plans" className="px-5 py-2.5 rounded-xl border border-indigo-300 dark:border-indigo-700/60 text-indigo-700 dark:text-indigo-300 text-sm font-semibold no-underline whitespace-nowrap">
                        Compare plans
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="mt-4 rounded-2xl border border-gray-200 dark:border-gray-700/60 p-6">
                  <h3 className="text-lg font-bold dark:text-white">Pay-as-you-go tools</h3>
                  <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                    AI Images and Text-to-Speech are billed separately, only when you use them — no monthly commitment.
                  </p>
                  <div className="flex flex-wrap gap-2 mt-3">
                    <Link to="/ai-image-generation" className="px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 text-sm font-medium hover:bg-gray-50 dark:hover:bg-[#2c2f44] no-underline dark:text-white">AI Images</Link>
                    <Link to="/text-to-speech" className="px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 text-sm font-medium hover:bg-gray-50 dark:hover:bg-[#2c2f44] no-underline dark:text-white">Text to Speech</Link>
                  </div>
                </div>
              </div>
            </Tab>
            <Tab eventKey="team" title="Team">
              Feature Comming Soon
            </Tab>
          </Tabs>
        </div>
      </div>
      
    );
  }else{
    return navigate("/")
  }
}



export default Settings;